import ActivityView from "./ActivityView";

export default ActivityView;
